module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d63a5fba92492bab99136021a79d43a3.png";